import { render, staticRenderFns } from "./pgmxDialog.vue?vue&type=template&id=55f43bca&scoped=true&"
import script from "./pgmxDialog.vue?vue&type=script&lang=js&"
export * from "./pgmxDialog.vue?vue&type=script&lang=js&"
import style0 from "./pgmxDialog.vue?vue&type=style&index=0&id=55f43bca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f43bca",
  null
  
)

export default component.exports